<template>
  <node-view-wrapper as="div" class="raw-html-block" contenteditable="false">
    <div class="raw-html-block-label">
      <span>Bloque HTML personalizado</span>
      <button type="button" class="raw-html-block-toggle" @click="toggleEdit">
        {{ editing ? 'Vista previa' : 'Editar código' }}
      </button>
    </div>

    <textarea
        v-if="editing"
        v-model="localHtml"
        class="raw-html-block-textarea"
        spellcheck="false"
        placeholder="Pega o escribe aquí tu HTML/CSS..."
        @blur="applyChanges"
    ></textarea>

    <!-- eslint-disable-next-line vue/no-v-html -->
    <div v-else class="raw-html-block-preview" v-html="node.attrs.html"></div>
  </node-view-wrapper>
</template>

<script>
import { NodeViewWrapper, nodeViewProps } from '@tiptap/vue-3'

export default {
  name: 'RawHtmlNodeView',

  components: {
    NodeViewWrapper,
  },

  props: nodeViewProps,

  data() {
    return {
      editing: !this.node.attrs.html,
      localHtml: this.node.attrs.html,
    }
  },

  methods: {
    toggleEdit() {
      if (this.editing) {
        this.applyChanges()
      } else {
        this.localHtml = this.node.attrs.html
      }
      this.editing = !this.editing
    },
    applyChanges() {
      this.updateAttributes({ html: this.localHtml })
    },
  },
}
</script>

<style scoped>
.raw-html-block {
  margin: 12px 0;
  padding: 8px;
  border: 2px dashed #d97706;
  border-radius: 0.375rem;
  background: #fffbeb;
}

.raw-html-block-label {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 6px;
  font-size: 0.7rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  color: #92400e;
}

.raw-html-block-toggle {
  padding: 2px 6px;
  font-size: 0.75rem;
  font-weight: 500;
  text-transform: none;
  letter-spacing: normal;
  color: #045DB5;
  background: transparent;
  border: none;
  cursor: pointer;
}

.raw-html-block-toggle:hover {
  text-decoration: underline;
}

.raw-html-block-textarea {
  width: 100%;
  min-height: 120px;
  padding: 8px;
  font-family: monospace;
  font-size: 0.8rem;
  color: #374151;
  background: white;
  border: 1px solid #d1d5db;
  border-radius: 0.25rem;
  resize: vertical;
}

.raw-html-block-preview {
  min-height: 24px;
}
</style>
